<template>
  <Modal>
    <Modal.Title>{{ title }}</Modal.Title>
    <DacrMembershipBody desktop />
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal } from '@dacr/library'

import { useBillingStore } from '@/features/billing/store'
import DacrMembershipBody from './DacrMembershipBody.vue'

const billingStore = useBillingStore()
const title = computed(() =>
  billingStore.isBasicMembership
    ? 'Dacr Basic Membership'
    : 'Dacr Pro Membership'
)
</script>
